export const SIDEBAR_ID = 'sidebar';
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@9.14.1 (2aac35652)
